/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Toast_Uploading_FilesInputs */

const en_toast_uploading_files = /** @type {(inputs: Toast_Uploading_FilesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Uploading ${i?.count} file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Uploading ${i?.count} files`);
	return /** @type {LocalizedString} */ ("toast_uploading_files");
};

const es_toast_uploading_files = /** @type {(inputs: Toast_Uploading_FilesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Subiendo ${i?.count} archivo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Subiendo ${i?.count} archivos`);
	return /** @type {LocalizedString} */ ("toast_uploading_files");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Uploading {count} file" |
* | "other" | "Uploading {count} files" |
*
* @param {Toast_Uploading_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_uploading_files = /** @type {((inputs: Toast_Uploading_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Uploading_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_uploading_files(inputs)
	return en_toast_uploading_files(inputs)
});